import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import Settings from "app/pages/activation/modules/Settings/Settings";
import {
    ACTIVATION_ROOT_ROUTE,
    ACTIVATION_SETTINGS_ROUTE,
    ACTIVATION_SETTINGS_URL,
    DEFAULT_ACTIVATION_GRANULARITY,
} from "app/pages/activation/routing/constants";
import { onRedirectToActivation } from "app/pages/activation/routing/redirectHooks/onRedirectToActivation";
import { onSettingsRedirect } from "app/pages/activation/routing/redirectHooks/onSettingsRedirect";
import { CONFIG_ID } from "app/pages/benchmark-tracker";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";

import { SECONDARY_BAR_TYPE } from "./constants";

export const settingsConfig = {
    [ACTIVATION_SETTINGS_ROUTE]: {
        parent: ACTIVATION_ROOT_ROUTE,
        url: `${ACTIVATION_SETTINGS_URL}/:key/:country/:webSource/:domain?timeGranularity&tab&scrollToAlerts`,
        params: {
            tab: {
                dynamic: true,
                value: "0",
            },
        },
        component: Settings,
        configId: CONFIG_ID,
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        trackingId: {
            section: "activation",
            subSection: "activation page",
            subSubSection: "settings",
        },
        defaultQueryParams: {
            timeGranularity: DEFAULT_ACTIVATION_GRANULARITY,
        },
        redirectTo: redirectPipe(onSettingsRedirect() as any, onRedirectToActivation() as any),
        pageTitle: "activation.page.settings.title",
        isSecondaryBarOpen: false,
        secondaryBarType: SECONDARY_BAR_TYPE,
        secondaryBarType3: SecondarySideBarType3.Activation,
        hideSecondaryBar3: true,
        hideFromRecents: true,
        isPrimarySidebarAlwaysOpen: true,
    },
};

